"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SBTUpgradeable__factory = void 0;

var _ethers = require("ethers");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const _abi = [{
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    indexed: true,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "Transfer",
  type: "event"
}, {
  inputs: [{
    internalType: "address",
    name: "owner",
    type: "address"
  }],
  name: "balanceOf",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "name",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "ownerOf",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes4",
    name: "interfaceId",
    type: "bytes4"
  }],
  name: "supportsInterface",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "symbol",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "tokenURI",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "transferFrom",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}];
const _bytecode = "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";

const isSuperArgs = xs => xs.length > 1;

class SBTUpgradeable__factory extends _ethers.ContractFactory {
  constructor(...args) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(overrides) {
    return super.deploy(overrides || {});
  }

  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }

  attach(address) {
    return super.attach(address);
  }

  connect(signer) {
    return super.connect(signer);
  }

  static createInterface() {
    return new _ethers.utils.Interface(_abi);
  }

  static connect(address, signerOrProvider) {
    return new _ethers.Contract(address, _abi, signerOrProvider);
  }

}

exports.SBTUpgradeable__factory = SBTUpgradeable__factory;

_defineProperty(SBTUpgradeable__factory, "bytecode", _bytecode);

_defineProperty(SBTUpgradeable__factory, "abi", _abi);